import React from "react";
import AnimatedSection from "./AnimatedSection";
import EstimateProjectForm from "../EstimateProjectForm";

const highlights = [
  {
    title: "Fast Performance",
    description: "Lightning-fast load times and optimized code for peak speed.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M13 2L4.5 13.5H11L10 22L19.5 10.5H13V2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Secure",
    description: "Enterprise-grade security built into every layer of your site.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3L5 6.5V11.5C5 16.5 8.5 20.5 12 21.5C15.5 20.5 19 16.5 19 11.5V6.5L12 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M9.5 12L11 13.5L14.5 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Responsive",
    description: "Flawless experience across desktop, tablet, and mobile devices.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="5" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 21h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "SEO Ready",
    description: "Built-in SEO best practices to rank higher on search engines.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 18V8M4 18h16M8 14V11M12 14V6M16 14V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
];

const WdevIntroSection: React.FC = () => {
  return (
    <section className="wdev-intro" aria-labelledby="wdev-intro-title">
      <div className="container">
        <div className="wdev-intro__grid">
          <AnimatedSection className="wdev-intro__content">
            <span className="wdev-label wdev-label--purple">Web Development</span>
            <h2 id="wdev-intro-title" className="wdev-intro__title">
              Reach Out To Your Audience Without Hiccups
            </h2>

            <p className="wdev-intro__text">
              The service we provide will ensure that you have a handy and attuned
              website to reach out to your audience on a wide range of platforms
              and devices. We provide end-to-end service with the knowledge you
              need to maintain further.
            </p>
            <p className="wdev-intro__text">
              Apart from preparing your website to be eye-catching and original,
              it will be SEO-friendly, responsive, and content-based. We cater
              according to the demands of our clients in a cost-effective way.
            </p>

            <div className="wdev-intro__highlights">
              {highlights.map((item) => (
                <div className="wdev-intro__highlight" key={item.title}>
                  <div className="wdev-intro__highlight-icon">{item.icon}</div>
                  <div>
                    <h3 className="wdev-intro__highlight-title">{item.title}</h3>
                    <p className="wdev-intro__highlight-desc">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </AnimatedSection>

          <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
            <EstimateProjectForm />
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default WdevIntroSection;
